import { IChoice } from "@components/inputs/DropDownMenu";

/**
 * Plan type constants used to show specific plan-related fields and components
 */
export enum PlanType {
  FLEXI_OWN = "fo",
  FLEXI_TRY = "ft",
};

/**
 * Eligibility conditions a customer must meet to opt out of a cover.
 * Shared by the Payout Protection and Part C (Loss & Damage) opt-out evidence dropdowns —
 * the same six conditions apply to both.
 */
export const optOutEvidenceOptions: IChoice[] = [
  {
    label: "Over 5K Uber Trips",
    value: "Over 5K Uber Trips",
    enabled: true,
  },
  {
    label: "Proven history of chauffeur work",
    value: "Proven history of chauffeur work",
    enabled: true,
  },
  {
    label: "Proven history of buying and selling multiple vehicles",
    value: "Proven history of buying and selling multiple vehicles",
    enabled: true,
  },
  {
    label: "Evidence of owning their own home",
    value: "Evidence of owning their own home",
    enabled: true,
  },
  {
    label: "Evidence of separate income provided and approved",
    value: "Evidence of separate income provided and approved",
    enabled: true,
  },
  {
    label: "Provided a credit check and has been approved internally",
    value: "Provided a credit check and has been approved internally",
    enabled: true,
  },
];

export const optOutDeclarationLabel = (agentName: string | undefined, coverName: string): string =>
  `I, ${agentName}, declare that the customer has provided sufficient evidence to opt-out of ${coverName}, and I have followed the prescribed process.`;

/**
 * Chargebee components for optional plan features
 */
export enum OptionalChargebeeComponents {
  PAYOUT_PROTECTION_FEE = "payoutprotectionfee",
  LOSS_AND_DAMAGE_PAYMENT = "lossanddamagepayment",
  LOSS_AND_DAMAGE_COVER_VEHICLE = "lossanddamagecovervehicle",
  LOSS_AND_DAMAGE_COVER_PAYMENT_TPP = "lossanddamagecoverpaymenttpp",
  LOSS_AND_DAMAGE_COVER_TPP_AND_PI = "lossanddamagecovertppandpi",
  SPLEND_MANAGEMENT_FEE = "splendmanagementfee",
  LOSS_AND_DAMAGE_COVER_PLUS = "lossanddamagecoverplus",
  SERVICING = "servicing",
  CONSUMABLES = "consumables",
};
